import React, { memo } from "react";
import closeIcon from "../../../assets/icons/closeIcon.svg";
import { amountFormatter } from "./../../../utils/utils";

const FilterDetailBar = memo(({ searchTerm, setSearchTerm, labelFields }) => {
  console.log({ searchTerm });
  const cleanedSearchTerm = Object.entries(searchTerm).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== "" && value !== null) {
        acc[key] = value;
      }

      return acc;
    },
    {}
  );

  const translatedArray = Object.entries(cleanedSearchTerm).map(
    ([key, value]) => {
      console.log(value ,"in filter bar")
      const translatedKey = labelFields[key] || key;
     
      if (key === "min_amount" || key === "max_amount") {
        value = amountFormatter(value);
      }
      if (key === "application") {
        value = value?.label;
      }

      return {
        englishKey: key,
        persianKey: translatedKey,
        value: value,
      };
    }
  );

  const removeSearchItemHandler = (name) => {
    setSearchTerm((prev) => ({ ...prev, [name]: "" }));
  };

  return (
    <div className="my-2 rounded-lg flex flex-wrap gap-1 w-full">
      {translatedArray.map((item, i) => {
        return (
          <div className="flex justify-between bg-secondary-20   px-1 gap-[1px] rounded-md text-dark title-[6px]">
            <button onClick={(e) => removeSearchItemHandler(item.englishKey)}>
              <img
                className=" hover:bg-slate-200  "
                src={closeIcon}
                alt="close-icon"
                width={24}
                height={24}
              />
            </button>
            <div className="flex gap-1" key={i}>
              <p>{item.persianKey}</p>:<p> {item?.value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default FilterDetailBar;
